import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface AuditEntry {
  id: string
  action: string
  targetName: string
  actor: string
  beforeState: unknown
  afterState: unknown
  reason: string | null
  createdAt: string
}

interface AdminAuditFeedResponse {
  entries: AuditEntry[]
  nextCursor: string | null
}

interface Props {
  feedUrl: string
  renderAction?: (entry: AuditEntry) => string
}

export function AdminAuditFeed({ feedUrl, renderAction }: Props) {
  const { data, isLoading } = useQuery({
    queryKey: ['audit-feed', feedUrl],
    queryFn: () => api.get<AdminAuditFeedResponse>(feedUrl),
    refetchInterval: 30_000,
  })

  if (isLoading) {
    return <div className="text-sm text-muted-foreground">Loading audit log…</div>
  }

  if (!data?.entries?.length) {
    return <div className="text-sm text-muted-foreground">No audit entries.</div>
  }

  return (
    <div className="space-y-2">
      {data.entries.map((entry) => (
        <div
          key={entry.id}
          className="flex items-start justify-between gap-3 rounded-md border px-3 py-2 text-sm"
        >
          <div className="flex-1">
            <div className="font-medium">
              {renderAction ? renderAction(entry) : entry.action}
            </div>
            <div className="text-xs text-muted-foreground">
              {entry.actor} · target: {entry.targetName} ·{' '}
              {new Date(entry.createdAt).toLocaleString()}
            </div>
            {entry.reason && <div className="text-xs mt-1">{entry.reason}</div>}
          </div>
        </div>
      ))}
    </div>
  )
}
